import request from '@/config/axios'

export interface FirmReconCheckVO {
  code?: string
  name?: string
  leftLabel?: string
  leftValue?: number
  rightLabel?: string
  rightValue?: number
  diff?: number
  ok?: boolean
  note?: string
}

export interface FirmReconSummaryVO {
  firmId: number
  firmName?: string
  retainRate?: number
  walletAvailable?: number
  walletFrozen?: number
  walletTotalIn?: number
  walletTotalOut?: number
  applyApprovedAmount?: number
  linkedOrderLawyerAmount?: number
  creditSum?: number
  debitPayoutSum?: number
  settledSplitSum?: number
  settledOrderLawyerAmount?: number
  paidCommAmount?: number
  pendingFirmCreditedAmount?: number
  checks?: FirmReconCheckVO[]
  hasDiff?: boolean
}

export interface FirmWalletLedgerVO {
  id: number
  ledgerNo?: string
  firmId?: number
  bizType?: string
  bizId?: number
  orderId?: number
  applyId?: number
  amount?: number
  balanceAfter?: number
  idempotencyKey?: string
  remark?: string
  createTime?: string
}

export interface FirmReconQuery {
  firmId?: number
  periodStart?: string
  periodEnd?: string
  onlyDiff?: boolean
}

export const FirmSettleReconApi = {
  list: async (params: FirmReconQuery) => {
    return await request.get<FirmReconSummaryVO[]>({
      url: '/lawyer/firm-settle-recon/list',
      params
    })
  },
  summary: async (params: { firmId: number; periodStart?: string; periodEnd?: string }) => {
    return await request.get<FirmReconSummaryVO>({
      url: '/lawyer/firm-settle-recon/summary',
      params
    })
  },
  ledgerPage: async (params: {
    firmId: number
    bizType?: string
    pageNo?: number
    pageSize?: number
  }) => {
    return await request.get<{ list: FirmWalletLedgerVO[]; total: number }>({
      url: '/lawyer/firm-settle-recon/ledger-page',
      params
    })
  }
}
